if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.cardStyle = this.dataset.cardStyle;
      this.itemSize = this.dataset.itemSize;
      this.columnsDesktop = this.dataset.columnsDesktop;

      this.sliderInstance = false;

      const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
      
      // Update the onchange handler to also call init and update the scroll message
      mql.onchange = (e) => {
          this.init();
          this.updateScrollMessage();
      };
      
      this.init();
    }

    init() {
      // Assuming you want the slider to run on ALL screen sizes now, 
      // as the carousel structure is often used for mobile scrolling.
      // If the theme configuration is forcing a grid layout on mobile, 
      // you must prevent it from destroying the slider instance.
      
      // We will simply ensure the slider is initialized:
      this.initSlider();
      
      // Call after any init to ensure text is correct for the current state
      this.updateScrollMessage(); 
    }

    initSlider() {
      const sliderOptions = {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination, FoxTheme.Swiper.Mousewheel],
        slidesPerView: 'auto',
        spaceBetween: 8,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        loop: false,
        threshold: 2,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          768: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView: this.itemSize == 'fixed' ? (this.columnsDesktop > 4 ? 4 : this.columnsDesktop) : 'auto',
          },
          1024: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView:
              this.itemSize == 'fixed'
                ? this.columnsDesktop > 6
                  ? this.columnsDesktop - 1
                  : this.columnsDesktop
                : 'auto',
          },
          1280: {
            spaceBetween: this.cardStyle == 'card' ? 8 : 20,
            slidesPerView: this.itemSize == 'fixed' ? this.columnsDesktop : 'auto',
          },
        },
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();
        
        // Call the update function immediately after initialization
        this.updateScrollMessage(); 

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideTo(index);
          });
        }
      }
    }
    
    // --- START: NEW METHOD FOR SCROLL MESSAGE ---
    updateScrollMessage() {
      const sectionId = this.sectionId;
      const container = document.getElementById(`collection-list-footer-${sectionId}`);
      
      if (!container) return; 

      const textElement = container.querySelector('.collection-list-footer__text');
      if (!textElement) return;
      
      const swiper = this.sliderInstance && this.sliderInstance.slider;
      
      // Determine if the slider content is scrollable
      // swiper.isBeginning !== swiper.isEnd is a reliable check if the loop is false
      // If the slider is not initialized, we default to not scrollable.
      const isScrollable = swiper ? (swiper.isBeginning !== swiper.isEnd) : false;

      // Check for mobile viewport size (using 768px as the common breakpoint)
      const isMobile = window.innerWidth < 768; 

      let newText = '';

      if (isScrollable) {
        // Scrollable text (with arrows)
        if (isMobile) {
          newText = container.getAttribute('data-mobile-scroll-text');
        } else {
          newText = container.getAttribute('data-desktop-scroll-text');
        }
      } else {
        // Not scrollable (select to view more)
        if (isMobile) {
          newText = container.getAttribute('data-mobile-select-text');
        } else {
          // On desktop, if it's not scrollable, maybe hide it entirely 
          // or show the 'Select to view more' text.
          newText = container.getAttribute('data-desktop-select-text');
        }
      }

      // Update the text content and visibility
      if (newText) {
          textElement.textContent = newText;
          container.style.display = 'block'; // Use 'block' to override the default 'none'
      } else {
          container.style.display = 'none'; // Hide if no text is set
      }
    }
    // --- END: NEW METHOD FOR SCROLL MESSAGE ---


    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }
  }
  customElements.define('collection-list', CollectionList);
}